<div class="accordion-container">
  <dx-accordion
    [dataSource]="modules"
    class="question-accordion"
    [collapsible]="true"
    [multiple]="true"
    selectedIndex="-1"
  >
    
    <div *dxTemplate="let module of 'title'" class="category-header">
      <div class="align-options">
        <span class="font-bold">{{ translatedModules[module.module] }}</span>
      </div>
    </div>

   
    <div *dxTemplate="let module of 'item'" class="category-content">
      <div *ngFor="let permession of module.permession">
        <div class="form-group">
          <label>{{ dataService.res(permession.permessionName) }}:</label>
          <abc-select-box
            class="selectBox"
            [(value)]="permession.permession"
            [dataSource]="dataSource"
            displayExpr="displayText"
            valueExpr="value"
            (onValueChanged)="onPermissionChange($event, permession,module)"
          ></abc-select-box>
        </div>
      </div>

  
    </div>
  </dx-accordion>
</div>
